import { getJson, postJson } from "../../core/http";

export function fetchCreditsInsights(window = "30d", { activityPage = 1, activityPerPage = 10 } = {}) {
  const params = new URLSearchParams({
    window: String(window),
    activity_page: String(activityPage),
    activity_per_page: String(activityPerPage),
  });
  return getJson(`/api/v1/credits/insights?${params.toString()}`);
}

export function topUpCredits({ amount, packageName, idempotencyKey } = {}) {
  return postJson("/api/v1/credits/top_up", {
    amount,
    package: packageName,
    idempotency_key: idempotencyKey,
  });
}
